import { Component } from '@angular/core';
import { DetailRequest } from '../detail-request/detail-request';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TicketCart } from '../../shared/models/components-general/card.model';
import { MatPaginator } from '@angular/material/paginator';
import { TicketService } from '../../shared/services/ticket.service';
import { CardRequest } from '../card-request/card-request';
import { MatTableDataSource } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GeneralService } from '../../shared/services/general.service';
import { TableGeneralComponent } from '../../shared/components-generals/table-general/table-general.component';
import { Subscription } from 'rxjs';
import { WorkFlowProject } from '../../shared/models/ticket-model/tiket.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-my-requests',
  imports: [
    CardRequest,
    MatPaginator,
    TableGeneralComponent,
    MatIcon,
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './my-requests.html',
  styleUrl: './my-requests.css',
})
export class MyRequests {
  public headers = [
    { value: 'Key', description: 'LocationKey' },
    { value: 'ID', description: 'Folio' },
    { value: 'Name', description: 'Nombre de cliente' },
    { value: 'WorkFlow', description: 'Flujo de trabajo' },
    { value: 'WorkFlowType', description: 'Tipo de flujo' },
    { value: 'State', description: 'Estatus' },
    { value: 'StartDate', description: 'Fecha de inicio' },
    { value: 'ClosingDate', description: 'Fecha de cierre' },
    { value: 'Description', description: 'Descripción' },
  ];
  public dataLength = 0;
  public isTable = true;
  public isLoading = false;
  public workFlowProject: WorkFlowProject[] = [];
  public workFlowProjectCards: TicketCart[] = [];
  public dataSource = new MatTableDataSource<any>([]);
  public pageSize = 8;
  public pageIndex = 1;
  public searchKey = '';

  private filterSubscription: Subscription[] = [];

  constructor(
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private ticketService: TicketService,
    private generalService: GeneralService,
  ) {}

  ngOnInit(): void {
    this.suscribeEvents();
    this.getWorkFlowProjects();
  }

  ngOnDestroy() {
    if (this.filterSubscription.length) {
      this.filterSubscription.forEach((subscription) => subscription.unsubscribe());
    }
  }

  suscribeEvents() {
    this.filterSubscription.push(
      this.generalService.searchKey.subscribe((key) => {
        console.log('Received search key:', key);
        this.pageIndex = 1;
        const searchResults = this.searchWorkFlowProjects(key);
        if (searchResults.length) {
          this.dataLength = searchResults.length;
          this.createCards(searchResults);
        } else {
          this.dataLength = this.workFlowProject.length;
          this.createCards(this.workFlowProject);
        }
      }),
    );

    // this.filterSubscription.push(
    //   this.generalService.emitFilterTiket.subscribe((filterData) => {
    //     let Sort: string | undefined = undefined;
    //     let SortDir: any = undefined;
    //     for (const key in filterData.sort) {
    //       if (filterData.sort[key] !== null && filterData.sort[key] !== undefined) {
    //         Sort = key;
    //         SortDir = filterData.sort[key];
    //         break;
    //       }
    //     }
    //   }),
    // );
  }

  public searchWorkFlowProjects(keyword: string): WorkFlowProject[] {
    if (!keyword || !this.workFlowProject?.length) return [];
    const lowerKeyword = keyword.toLowerCase();
    return this.workFlowProject.filter((item) => {
      return Object.values(item).some((value) => {
        if (value == null) return false;
        return value.toString().toLowerCase().includes(lowerKeyword);
      });
    });
  }

  public getWorkFlowProjects(): void {
    this.ticketService.getWorkFlowProjects().subscribe((response) => {
      if (response && response.Data) {
        // Ordenar por id ascendente (o usa 'Key' si no hay 'id')
        const sorted = [...response.Data].sort((a, b) => {
          const idA = a.Id ?? 0;
          const idB = b.Id ?? 0;
          return idA < idB ? 1 : idA > idB ? -1 : 0;
        });
        this.workFlowProject = sorted;
        this.dataLength = this.workFlowProject.length;
        this.createCards(this.workFlowProject);
      }
      this.isLoading = false;
    });
  }

  public createCards(data: WorkFlowProject[]): void {
    // Calcular el rango de paginación
    const start = (this.pageIndex - 1) * this.pageSize;
    const end = start + this.pageSize;
    const pagedProjects = data.slice(start, end);

    this.workFlowProjectCards = pagedProjects.map((item) => ({
      id: item.Key,
      title: `Folio:`,
      data: [
        { description: 'ID', value: item.LocationKey },
        { description: 'Nombre de cliente', value: item.Name ?? 'Red Jalisco' },
        { description: 'Flujo de trabajo', value: item.WorkFlow },
        { description: 'Tipo de flujo', value: item.WorkFlowType },
        { description: 'Estatus', value: item.State },
        {
          description: 'Fecha de inicio',
          value: item.StartDate && item.StartDate != '' ? item.StartDate : '-',
        },
        // {
        //   description: 'Fecha de cierre',
        //   value: item.ClosingDate && item.ClosingDate != '' ? item.ClosingDate : '-',
        // },
        { description: 'Descripción', value: item.Description ?? '-' },
      ],
      textButton: 'Ver detalles',
    }));
    this.dataSource.data = pagedProjects;
  }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.createCards(this.workFlowProject);
  }

  public openDetailRequest(id: number | string): void {
    this.generalService.goToUrl(['detail-request'], { Folio: id });
  }

  public changeTable(isTable: boolean): void {
    this.isTable = isTable;
  }
}
